<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.no" clearable placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" clearable placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.no" width="100"/>
        <vxe-column field="name" title="business.label.name" width="200"/>
        <vxe-column field="address.addressInfo.detailAddress" title="business.label.address"/>
        <vxe-column field="orderStrategy.name" title="business.label.orderStrategy" width="120"/>
        <vxe-column field="waveStrategy.name" title="business.label.waveStrategy" width="120"/>
        <vxe-column field="pickingContainerType.name" title="business.label.pickingContainerType" width="120"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:additionPickingModes}" field="additionPickingMode" title="business.label.additionPickingMode" width="120"/>
        <vxe-column field="weightDeviation" title="business.label.weightDeviation" width="80"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="taskPrebuilt" title="business.label.taskPrebuilt" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="orderSplitting" title="business.label.orderSplitting" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="copy(row)"/>
            <vxe-button content="business.label.config" icon="vxe-icon-association-form" status="primary" @click.stop="config(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import { Warehouse } from '@/api/dto/common/Warehouse'

export default {
  name: 'WarehouseTable',
  data() {
    return {
      loading: false,
      query: new Warehouse(),
      list: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  props: {
    additionPickingModes: {
      type: Array,
      default: []
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('warehouseFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.list = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new Warehouse()
      this.refresh()
    },
    add() {
      this.$emit('add')
    },
    edit(row) {
      this.$emit('edit', row.id, false)
    },
    copy(row) {
      this.$emit('edit', row.id, true)
    },
    config(row) {
      this.$emit('config', new Warehouse(row))
    }
  }
}
</script>